import React, { Fragment } from "react";
import { Button, UncontrolledTooltip, Col, Card, CardBody, CardHeader } from "reactstrap";
import { GetRiskClassName, LoadingMessage } from "./helper";
import style from "./styles.module.scss";

export const AccountRiskWidget = ({ info, link: Link, to }) => (
  <div className={style.riskWidget}>
    <span className={style.warning} id="warning-risk">
      {info.AccountProfileRiskMismatch && (
        <Fragment>
          <i className="fa fa-exclamation-triangle mr-2" aria-hidden="true" />
          Profile mismatch warning
          <UncontrolledTooltip placement="top" target="warning-risk">
            Go to risk page and check
          </UncontrolledTooltip>
        </Fragment>
      )}
    </span>
    <div className={style.line}>
      <span className="font-sm mr-2">Investor profile</span>
      <Button tag={Link} to={to} color={GetRiskClassName(info.AccountProfileRisk)} size="sm">
        {info.AccountProfileRisk}
      </Button>
    </div>
    <div className={style.line}>
      <span className="font-sm mr-2">Account Risk</span>
      <Button tag={Link} to={to} color={GetRiskClassName(info.AccountRisk)} size="sm">
        {info.AccountRisk}
      </Button>
    </div>
  </div>
);

export const CardWrapper = ({ title, children, loading, lg, xs, style = {} }) => (
  <Col lg={lg} xs={xs} style={style}>
    <Card className={style.cardlg} style={{ height: "100%" }}>
      <CardHeader className="pt-2 pb-2">{title}</CardHeader>
      <CardBody className="pl-3 pr-3">
        {loading ? <LoadingMessage className={style.loading} text="Retrieving account info" /> : children}
      </CardBody>
    </Card>
  </Col>
);
